<template>
  <v-hover v-slot:default="{ hover }" :key="item.title">
    <v-list-item
      :style="normalizeOffset"
      v-bind:[isLink]="item.to"
      :disabled="item.disabled"
      v-on:[isEvent]="$emit('click', item)"
    >
      <v-list-item-icon v-if="item.icon">
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="menu-item">
          {{ item.title }}
        </v-list-item-title>
      </v-list-item-content>

      <div
        v-if="item.actions && hover"
        style="position: absolute; top: 0; right: 10px"
      >
        <v-list-item-action
          class="mr-0 ml-0"
          v-for="itemAction in item.actions"
          :key="itemAction.id"
        >
          <v-btn icon x-small @click="$emit('action', itemAction)">
            <v-icon>{{ itemAction.icon }}</v-icon>
          </v-btn>
        </v-list-item-action>
      </div>
    </v-list-item>
  </v-hover>
</template>

<script>
export default {
  name: 'DefaultMenuItem',
  computed: {
    isLink() {
      if (this.item.to) {
        return 'to';
      }
      return null;
    },
    isEvent() {
      if (!this.item.to) {
        return 'click';
      }
      return null;
    },
    normalizeOffset() {
      return {
        paddingLeft: this.item.fixNestedOffset ? '8px' : 'auto'
      };
    }
  },
  props: {
    isChild: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
